export enum MessageType{
    START_SCRAPING = "START_SCRAPING",
    REPORT_SCRAPING_ERROR = "REPORT_SCRAPING_ERROR",
    REPORT_SCRAPING_ACTION_REQUEST = "REPORT_SCRAPING_ACTION_REQUEST",
    REPORT_SCRAPING_PROGRESS = "REPORT_SCRAPING_PROGRESS",
    SEND_REPORT_SCRAPING_INPUT_REQUEST = "REPORT_SCRAPING_INPUT_REQUEST",
    RCV_REPORT_SCRAPING_INPUT_REQUEST = "RCV_REPORT_SCRAPING_INPUT_REQUEST",
    DONE_SCRAPING = "DONE_SCRAPING"

}

export interface IMessage<T> {
    type: MessageType
    payload: T
}